module.exports = __webpack_public_path__ + "static/whitepaper_es-fcff5e8e17ccc03edb35aee9e95a484c.pdf";